export enum PullRequestFollowStatus {
    Disabled = 0,
    Loading = 1,
    NotFollowed = 2,
    Followed = 3
}